/**
 * Where to go after signing in: the page a signed-out visitor was heading to (an email link,
 * a bookmark, or a page whose session expired). Kept for this tab only, in sessionStorage.
 */

const KEY = 'returnPath';

const NOT_WORTH_RETURNING_TO = ['/', '/login', '/register', '/forgot-password', '/auth/callback', '/auth/error'];

/** Only same-site paths: one leading slash, never "//host" or "/\host". */
export const isSafeReturnPath = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');

export const rememberReturnPath = (path: string): void => {
  const pathname = path.split(/[?#]/, 1)[0];
  if (!isSafeReturnPath(path) || NOT_WORTH_RETURNING_TO.includes(pathname)) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage blocked: the visitor simply lands on the default page after signing in
  }
};

/** The remembered path, removed as it is read, or null. */
export const takeReturnPath = (): string | null => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && isSafeReturnPath(path) ? path : null;
  } catch {
    return null;
  }
};
